export default __webpack_public_path__ + "static/media/dots-3.b6a1e844.svg";